import { Tab, Tabs, styled } from '@mui/material';

import React from 'react';

import styles from './TabStyle.module.scss';

const {
	selectedTextColor,
	textColor,
	selectedTabUnderlineColor,
	selectedTabBackground,
} = styles;
interface StyledTabsProps {
	children?: React.ReactNode;
	value: number;
	onChange: (event: React.SyntheticEvent, newValue: number) => void;
}
export const StyledLinedTabs = styled((props: StyledTabsProps) => (
	<Tabs
		sx={{
			'&.MuiToolbar-root': {
				paddingLeft: 0,
			},
		}}
		variant="fullWidth"
		{...props}
		TabIndicatorProps={{
			style: {
				backgroundColor: selectedTabUnderlineColor,
				height: 2,
			},
		}}
	/>
))({
	paddingTop: '6px',
	minHeight: '43px',

	paddingLeft: '6px',
	marginTop: '19px',
	'& .MuiTabs-indicator': {
		display: 'flex',
		justifyContent: 'center',
		backgroundColor: 'transparent',
	},
});

interface StyledTabProps {
	label: string;
}

export const StyledLinedTab = styled((props: StyledTabProps) => (
	<Tab disableRipple {...props} />
))(({ theme }) => ({
	textTransform: 'none',
	fontWeight: theme.typography.fontWeightRegular,
	marginRight: theme.spacing(1),
	minHeight: '1.5rem',
	fontSize: '16px',
	whiteSpace: 'nowrap',
	color: textColor,
	padding: '0px 10px',
	'&.Mui-selected': {
		color: selectedTextColor,
		height: '32px',
		alignItems: 'center',
		gap: '8px',
		borderRadius: '2px',
		minHeight: '1.5rem',
	},
	'&.Mui-focusVisible': {
		backgroundColor: selectedTabBackground,
	},
}));
